import { FC, useEffect, useRef, useState } from 'react';
// import { getIsLogin } from 'lowcode/utils/getIsLogin';
import Banner from '../Common/Banner';
import Refer from '../Common/Refer';
import Subscribe from '../Common/SubscribeReceive';
import Terms from '../Common/Terms';
import ProductGallery from '../Share/ProductGallery';
import Products from './Products';
import Rewards from './Rewards';
// import Blogs from './Blogs';
import getLocal from '@/app/utils/getLocal';
import BenefitsNew from '@/components/EcoCredits/BenefitsNew';
import { useReferralDispatch, useReferralStore } from '@/components/Referral/ReferralProvider';
import { message } from '@/components/UI';
import Button from '@/components/UI/Button';
import EfModal from '@/components/UI/Modal';
import { checkInviteCode } from '@/service/referral';
import { loginUser } from '@/utils/cookie';
import { useGlobal } from '@/utils/useGlobal';
import Benefits from './Benefits';
import CallToActionBanner from './CallToActionBanner';
import JoinUs from './JoinUs';
import styled from './index.module.scss';
// import MemberCard from '../Share/MemberCard';
// import { PlanType } from '../index.d';
import { useMonthlyDispatch } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import { getRewardRuleList, getRewardUserLevel } from '@/service/vip';
import { signupCookie } from '@/utils/cookies/signupCookie';
import gtm from '@/utils/gtm';
import EfLink from 'elem/ui/ef-link';
import ReferModal, { ReferHandle } from '../Common/Referral';
import UserStories from '../Common/UserStories';
import { EuropeSites } from '../util';
import HowWorks from './HowWorks';
import Scene from './Scene';
import D3msOverView from './D3msOverView';
import BannerV2 from '../../Referral/CommonV2/Banner';
import ReceiveButton from './ReceiveButton';
import SpecialRewards from '../CommonV2/SpecialRewards';
import RewardsProgram from '../CommonV2/RewardsProgram';
import Purchase from '../CommonV2/Purchase';
import RealUsers from '../CommonV2/RealUsers';
import EcoButton from 'eco-design/base/eco-button';

const ReceiveCompoment: FC<{ isLogin: boolean }> = ({ isLogin }) => {
    const { useLang, useRouter, Link } = useGlobal();
    const router = useRouter();
    const referRef = useRef<ReferHandle>(null);
    const { locale, pathname } = getLocal();
    const { t } = useLang('referral');
    const { t: s } = useLang('ReauUsers');
    const dispatch = useReferralDispatch();
    const monthlyDispatch = useMonthlyDispatch();
    const { inBlackList, referralInfo, actStatus, pageUsing, isLogin: isLoginStore } = useReferralStore();
    // const isLogin = getIsLogin();
    const [codeState, setCodeState] = useState('0');
    const [userInfo, setUserInfo] = useState<any>({});
    const [show, setShow] = useState(false);
    const registerUrl = `/${locale}/register?inviteCode=${router.query.inviteCode}&redirect=${encodeURIComponent(`/${locale}${router.asPath}`)}`;

    const inviteErrorMap: Record<string, string> = {
        '2430': t('active_is_unstart'),
        '2431': t('active_is_ended'),
        '2438': t('invitation_expired'),
        '2439': t('invitation_ip'),
    };

    const isActivityWithNA = ['us', 'ca'].includes(locale) && actStatus === 1;

    // us/ca 活动期间文案修改，desc修改
    const getBannerText = () => {
        if (isActivityWithNA) return t('banner.desc2_1');
        return t('banner.desc2');
    };

    const getBannerTitle = () => {
        if (['us', 'ca'].includes(locale) && actStatus === 1) return t('banner.title_1');
        return t('banner.title');
    };

    useEffect(() => {
        let pageType = '';
        const { inviteCode } = router.query;
        if (pathname === '/referral-rewards-delta-pro-3-portable-power-station') {
            pageType = 'dp3';
        }
        // 不然被覆盖了 紧急需求 先这样吧
        if (pathname === '/referee-delta-3-max-series') pageType = 'd3ms';

        dispatch({ type: 'changePageUsingInfo', payload: pageType });
        dispatch({ type: 'getReferralInfoByInviteCode', payload: { locale, inviteCode } });
        checkCodeState();
        queryRewardUserLevel();
        setUserInfo(loginUser());
    }, []);

    // 检查 inviteCode 状态
    const checkCodeState = async () => {
        const { inviteCode } = router.query;
        // 如果没有邀请码 直接跳转分享页
        if (!inviteCode) {
            router.push(pageUsing === 'd3ms' ? '/referral-delta-3-max-series' : '/referral');
            return;
        }
        // const fp = await FingerprintJS.load();
        // const { visitorId } = await fp.get();
        const res = await checkInviteCode({ inviteCode }, locale);
        if (res.code !== '0') {
            setCodeState(res.code);
            inviteErrorMap[res.code] && message.error(inviteErrorMap[res.code]);
            if (res.code === '2439' || res.code === '2438') {
                router.push('/404');
            }
            if (res.code === '2440') {
                router.push(pageUsing === 'd3ms' ? '/referral-delta-3-max-series' : '/referral');
            }
        }
    };

    /**
     * 查询账户权益等级
     */
    const queryRewardUserLevel = async () => {
        const ruleRes = await getRewardRuleList(locale as string);
        if (ruleRes?.code !== '0') return;
        const plusMemberData = ruleRes.data.find((item) => item.level === 2);
        const memberData = ruleRes.data.find((item) => item.level === 1);
        const payload = {
            normalName: memberData?.name,
            plusName: plusMemberData?.name,
            minPoint: Number(plusMemberData?.minPoints),
        };

        if (isLogin) {
            const levelRes = await getRewardUserLevel(locale as string);
            if (levelRes?.code === '0' && levelRes.data) {
                const { level, validStartTime, validEndTime } = levelRes.data;
                const userLevelData = ruleRes.data.find((item) => item.level === level);

                Object.assign(payload, {
                    level,
                    validStartTime,
                    validEndTime,
                    name: userLevelData?.name || '',
                });
            }
        }
        monthlyDispatch({
            type: 'changeRewardUserLevel',
            payload,
        });
    };

    const toRegisterPage = (text: string) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'referral_button',
                position: 'Gifts Await You!',
                button_name: t('banner.btn'),
            });
        } catch (e) {
            console.log(e);
        }
        if (actStatus === 1) {
            signupCookie({ sector_name: getBannerTitle(), entry_position: 1 });
            location.href = `/${locale}/register?inviteCode=${router.query.inviteCode}&redirect=${encodeURIComponent(
                `https://${locale}.ecoflow.com/pages/prime-day`,
            )}`;
            return;
        }
        if (codeState === '2442') setShow(true);
        if (codeState !== '0') return;
        signupCookie({ sector_name: getBannerTitle(), entry_position: 1 });
        location.href = registerUrl;
    };

    const onCloseGtm = (btnName: string) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'popup_close',
                title_name: t('invitation_tips_title'),
                button_name: btnName,
            });
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        if (isLoginStore) {
            setUserInfo(loginUser());
        }
    }, [isLoginStore]);

    if (pageUsing === '') {
        return (
            <>
                <style jsx global>
                    {`
                        .ant-message {
                            z-index: 9999999;
                        }
                        .ant-modal-root {
                            z-index: 2102;
                        }
                    `}
                </style>

                <div className={`${styled.receive_compoment}`}>
                    <BannerV2
                        title={
                            isLoginStore
                                ? t.rich('banner.title2', {
                                      name: () => userInfo?.user?.name || userInfo?.user?.email,
                                  })
                                : getBannerTitle()
                        }
                        desc={
                            isLoginStore
                                ? getBannerText()
                                : isActivityWithNA
                                ? t('banner.desc_1')
                                : t.rich('banner.desc', {
                                      line1: (text: string) => (
                                          <a className="register_text" onClick={() => toRegisterPage(text)}>
                                              {text}
                                          </a>
                                      ),
                                  })
                        }
                        isInner={false}
                    >
                        {!isLoginStore && <ReceiveButton codeState={codeState} bannerTitle={getBannerTitle()} />}
                    </BannerV2>
                    {/* {isLogin && <Rewards />} */}
                    {isLoginStore && <SpecialRewards />}
                    <RewardsProgram codeState={codeState} />
                    <Purchase />
                    <RealUsers />

                    <div className="cta-wrapper">
                        <ReceiveButton codeState={codeState} bannerTitle={''} lTheme="black">
                            {isLoginStore ? s('btn2') : s('btn1')}
                        </ReceiveButton>
                        {/* <EcoButton lRadius="ellipse" lTheme="black">
                        
                    </EcoButton> */}
                    </div>

                    <div
                        className="terms-title"
                        onClick={() => {
                            window.open(`/${locale}/referral-terms?type=receive`, '_blank');
                        }}
                    >
                        {t('terms.title')}
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2102;
                    }
                `}
            </style>

            <div className={`${styled.receive_compoment}`}>
                <Banner
                    title={
                        isLogin
                            ? t.rich('banner.title2', {
                                  name: () => userInfo?.user?.name || userInfo?.user?.email,
                              })
                            : getBannerTitle()
                    }
                    desc={
                        isLogin
                            ? getBannerText()
                            : isActivityWithNA
                            ? t('banner.desc_1')
                            : t.rich('banner.desc', {
                                  line1: (text: string) => (
                                      <a className="register_text" onClick={() => toRegisterPage(text)}>
                                          {text}
                                      </a>
                                  ),
                              })
                    }
                    isInner={false}
                >
                    {!isLogin && (
                        <Button
                            className={`refer-btn ${EuropeSites.includes(locale) ? 'white' : ''}`}
                            onClick={() => toRegisterPage(t('banner.btn'))}
                            disabled={inBlackList}
                        >
                            {t('banner.btn')}
                        </Button>
                    )}
                </Banner>
                <CallToActionBanner />
                {pageUsing !== undefined && pageUsing !== 'dp3' && (
                    <>
                        {isLogin && <Rewards />}
                        {/* {referralInfo?.planType === PlanType.CAMPAIGN && (
                            <MemberCard title={t('member.title')} subTitle={t('member.subTitle')} cta={t('member.button')} />
                        )} */}
                        {/* <Blogs subScribe={() => subRef.current?.handleOpen()} /> */}
                        {/* <Benefits /> */}

                        {EuropeSites.includes(locale) && <HowWorks isLogin={isLogin} redirectUrl={registerUrl} />}
                        {!EuropeSites.includes(locale) && <BenefitsNew />}
                        <Products />
                        <ReferModal ref={referRef} hide />
                        {EuropeSites.includes(locale) && pageUsing !== 'd3ms' && <Scene />}
                        {pageUsing === 'd3ms' && <D3msOverView />}
                        {EuropeSites.includes(locale) && (
                            <UserStories
                                isLogin={isLogin}
                                handleShare={() => {
                                    if (!isLogin) {
                                        signupCookie?.({
                                            sector_name: getBannerTitle(),
                                            entry_position: 7,
                                        });
                                        router.push(
                                            `/${locale}/login?redirect=${encodeURIComponent(
                                                `/${locale}/${pageUsing === 'd3ms' ? 'referral-delta-3-max-series' : 'referral'}?pop=share`,
                                            )}`,
                                        );
                                    } else {
                                        router.push(`/${pageUsing === 'd3ms' ? 'referral-delta-3-max-series' : 'referral'}?pop=share`);
                                    }
                                }}
                                shareKey="Referral Page_Hear from Real Users"
                            />
                        )}

                        {!EuropeSites.includes(locale) && isLogin && <Refer isShare={false} />}
                        {!EuropeSites.includes(locale) && !['br', 'mx', 'ph'].includes(locale) && isLogin && <JoinUs />}
                        <Terms />
                        <Subscribe isShare={true} />
                    </>
                )}
                {pageUsing !== undefined && pageUsing === 'dp3' && (
                    <>
                        {isLogin && <Rewards />}
                        <ProductGallery />
                        <Products type="dp3" />
                        <Benefits />
                        {isLogin && <Refer isShare={false} />}
                        {isLogin && <JoinUs />}
                        <Terms />
                    </>
                )}

                <EfModal
                    width="560"
                    visible={show}
                    open={show}
                    className={`${styled.no_active_modal}`}
                    centered={true}
                    getContainer={true}
                    onCancel={() => {
                        setShow(false);
                        onCloseGtm('Close');
                    }}
                >
                    <div className="content">
                        <h5 className="title">{t('invitation_tips_title')}</h5>
                        <p className="msg">{t('invitation_tips_cotent')}</p>
                        <div className="tools">
                            <Button
                                className="btn later"
                                onClick={() => {
                                    setShow(false);
                                    onCloseGtm('Later');
                                }}
                            >
                                {t('invitation_tips_cancel')}
                            </Button>
                            <EfLink
                                href={registerUrl}
                                onClick={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'jump_button',
                                        position: 'Pop-up Reminder',
                                        button_name: t('invitation_tips_confirm'),
                                        url: registerUrl,
                                    });
                                }}
                            >
                                <Button className="btn">{t('invitation_tips_confirm')}</Button>
                            </EfLink>
                        </div>
                    </div>
                </EfModal>
            </div>
        </>
    );
};

export default ReceiveCompoment;
